import { Select, Spin } from 'antd';
const Option = Select.Option;
import React from 'react';
import moment from 'moment';
import Card from '$app/components/vendor/Card';
import toUpper from 'lodash/toUpper';
import Currency from '$app/components/vendor/Currency';
import Title from '$app/apps/bookings/components/Title';
import Table from '$app/apps/bookings/components/Table';
import ActionButton from '$app/apps/bookings/components/ActionButton';
import { HeaderDiv, InvoiceStatusSelect } from './styled';
import { TitleDiv } from '../WorkDetails/styled';

const renderPrice = p => <Currency trailingZero>{p}</Currency>;
const selectEnableStatus = ['submitted', 'on_hold'];
const isSelectDisable = status => selectEnableStatus.indexOf(status) === -1;
const getOptionsForStatus = status => {
  switch (status) {
    case 'submitted':
      return (
        <Option key="submitted" value="on_hold">
          ON_HOLD
        </Option>
      );
    case 'on_hold':
      return (
        <Option key="hold" value="submitted">
          SUBMITTED
        </Option>
      );
    default:
      return true;
  }
};
const handleStatusChange = (value, updateBill, garageBill) => {
  updateBill({
    oldStatus: toUpper(garageBill.invoiceStatus),
    newStatus: toUpper(value),
    data: {
      invoicesToUpdate: [
        {
          invoiceId: garageBill.invoiceId,
          bookingId: garageBill.bookingId,
        },
      ],
    },
  });
};

const columns = (garageBill, updateBillFunc) => [
  {
    title: 'Reference ID',
    dataIndex: 'referenceId',
    key: 'referenceId',
  },
  {
    title: 'Total (pre VAT)',
    dataIndex: 'pricePreVAT',
    key: 'pricePreVAT',
    render: p => renderPrice(p),
  },
  {
    title: 'Total (inc. VAT)',
    dataIndex: 'price',
    key: 'price',
    render: p => renderPrice(p),
  },
  {
    title: 'Invoice status',
    dataIndex: 'invoiceStatus',
    key: 'invoiceStatus',
    render: s => (
      <InvoiceStatusSelect
        disabled={isSelectDisable(s)}
        showArrow={!isSelectDisable(s)}
        className={s}
        style={{ width: 150 }}
        value={toUpper(s)}
        onChange={value => handleStatusChange(value, updateBillFunc, garageBill)}
      >
        {getOptionsForStatus(s)}
      </InvoiceStatusSelect>
    ),
  },
  {
    title: 'Last updated',
    dataIndex: 'updatedAt',
    key: 'updatedAt',
    render: t => moment(t).format('DD/MM/YY HH:mm'),
  },
];

const GarageInvoiceDetails = props => {
  const { garageBills, quote, updateGarageBill, onDownloadBill } = props;
  const activeBill = garageBills.find(gb => gb.status.trim() === 'active') || {};
  if (activeBill.quoteId !== quote.quoteId) return null;
  if (!activeBill.updatedAt) activeBill.updatedAt = activeBill.createdAt;
  Object.assign(activeBill, {
    key: activeBill.invoiceId,
    pricePreVAT: quote.garageTotalPriceWithoutVAT,
  });

  return (
    <Card>
      <HeaderDiv>
        <Title>Garage invoice</Title>
        <ActionButton onClick={onDownloadBill} icon="download">
          Garage Invoice
        </ActionButton>
      </HeaderDiv>
      <Table columns={columns(activeBill, updateGarageBill)} dataSource={[activeBill]} pagination={false} />
    </Card>
  );
};

export default GarageInvoiceDetails;
